import { render } from "./GenreList.vue?vue&type=template&id=576d2a38&scoped=true&ts=true"
import script from "./GenreList.vue?vue&type=script&lang=ts"
export * from "./GenreList.vue?vue&type=script&lang=ts"

import "./GenreList.vue?vue&type=style&index=0&id=576d2a38&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-576d2a38"]])

export default __exports__